import React, { useState, useEffect } from "react";
import Wrapper from "../../components/Wrapper";
import InnerNav from "../../components/InnerNav";
import { FiSave } from "react-icons/fi";
import axios from "axios";
import { Navigate } from "react-router-dom";
import Select from "react-select";

const InvoicefooterdetailCreate = () => {
  const [note, setNote] = useState("");
  const [slogan, setSlogan] = useState("");
  const [footerbgcolors, setFooterbgcolors] = useState("");
  const [redirect, setRedirect] = useState(false);
  const [bgColorList, setBgColorList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [hasError, setHasError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  useEffect(() => {
    const fetchBgColors = async () => {
      setLoading(true);
      setHasError(false);
      setErrorMessage("");

      try {
        const { data } = await axios.get(`invoicefooterbgcolor?page=${1}`);
        setBgColorList(data.data);
        //console.log(data.data);
      } catch (error) {
        if (error.response) {
          // The request was made and the server responded with a status code
          // that falls out of the range of 2xx
          if (error.response.status === 401) {
            setErrorMessage("Unauthorized access.");
          } else if (error.response.status === 400) {
            setErrorMessage("Bad request. Please check your input.");
          } else if (error.response.status === 500) {
            setErrorMessage("Insufficient Permissions");
          } else {
            setErrorMessage("An error occurred. Please try again later.");
          }
        } else if (error.request) {
          // The request was made but no response was received
          if (error.message === "Network Error") {
            setErrorMessage(
              "Failed to connect to the server. Please try again later.",
            );
          } else {
            setErrorMessage("No response received. Please try again later.");
          }
        } else {
          // Something happened in setting up the request that triggered an Error
          setErrorMessage("An error occurred. Please try again later.");
        }
        setHasError(true);
      } finally {
        setLoading(false);
      }
    };

    fetchBgColors();
  }, []);

  const submit = async (e) => {
    e.preventDefault();
    const { data } = await axios.post("invoicefooterdetail", {
      note,
      slogan,
      footer_bg_colors_id: parseInt(footerbgcolors),
    });
    console.log(data);
    setRedirect(true);
  };
  if (redirect) {
    return <Navigate to={"/invoicefooterdetail"} />;
  }
  return (
    <Wrapper pageTitle={"New Invoice Footer Detail"}>
      <InnerNav
        createLink={"/invoicefooterdetailCreate"}
        listLink={"/invoicefooterdetail"}
      />
      <form onSubmit={submit}>
        <div className="px-4 py-3 mb-8 bg-white rounded-lg shadow-md dark:bg-gray-800">
          <label className="block text-sm">
            <span className="text-gray-700 dark:text-gray-400">Note </span>
            <input
              className="block w-full p-2 border mt-1 text-sm border-gray-300 rounded-md h-10 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 form-input "
              placeholder="Note"
              onChange={(e) => setNote(e.target.value)}
            />
          </label>

          <label className="block text-sm">
            <span className="text-gray-700 dark:text-gray-400">Slogan </span>
            <input
              className="block w-full p-2 border mt-1 text-sm border-gray-300 rounded-md h-10 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 form-input "
              placeholder="Slogan"
              onChange={(e) => setSlogan(e.target.value)}
            />
          </label>

          <label className="block text-sm mb-4">
            <span className="text-gray-700 dark:text-gray-400">BG Color</span>
            <Select
              options={bgColorList.map((bgColor) => ({
                value: bgColor.id,
                label: `${bgColor.color_name} ${bgColor.color_name}`.trim(),
              }))}
              onChange={(selectedOption) =>
                setFooterbgcolors(selectedOption.value)
              }
            />
          </label>

          <div className="flex mt-6 text-sm">
            <label className="flex items-center dark:text-gray-400">
              <button
                className="flex items-center justify-between px-4 py-2 text-sm font-medium leading-5 text-white transition-colors duration-150 bg-blue-600 border border-transparent rounded-lg active:bg-white hover:bg-blue-400 focus:outline-none focus:shadow-outline-purple"
                onClick={submit}
              >
                {" "}
                <FiSave /> <span className="ml-3">Save</span>{" "}
              </button>
            </label>
          </div>
        </div>
      </form>
    </Wrapper>
  );
};
export default InvoicefooterdetailCreate;
